import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/onboarding", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function dismiss(requestOptions) {
  return __request__("PUT", "/onboarding/dismiss", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function finish(requestOptions) {
  return __request__("PUT", "/onboarding/finish", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
